"use client";
import { IUserData, IUsersBrandAccounts } from "@/types";
import { Label } from "@/components/ui/label";
import React from "react";
import { SetLocation } from "@/lib/api";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { IconLocation } from "@tabler/icons-react";
import * as Impersonate from "@/lib/impersonate_api";

interface Props {
    user: IUserData;
    updateUser: IUserData;
    setUpdateUser: React.Dispatch<React.SetStateAction<IUserData>>;
    admin?: boolean;
    impersonate?: boolean;
    ws?: WebSocket | null;
    loggedInUser?: IUsersBrandAccounts | undefined;
}
export default function Location({
    user,
    updateUser,
    setUpdateUser,
    admin,
    impersonate,
    ws,
    loggedInUser,
}: Props) {
    const [location, setLocation] = React.useState(
        updateUser.settings?.location || ""
    );
    const onLocationBlur = async () => {
        if (user.settings?.location == updateUser.settings?.location) return;
        const toastid = toast("Updating Location...");
        if (impersonate && ws && loggedInUser?.role !== "user") {
            ws.send(
                JSON.stringify({
                    type: "update_header",
                    data: {
                        pic: updateUser.pic,
                        displayname: updateUser.displayname,
                        bio: updateUser.bio,
                        pronouns: updateUser.settings?.pronouns || "",
                        location: updateUser.settings.location,
                        layout: updateUser.theme.layout,
                        design: updateUser.design,
                    },
                })
            );
        }
        let response: any;
        if (impersonate) {
            response = await Impersonate.SetLocation(
                user,
                updateUser.settings?.location || ""
            );
        } else {
            response = await SetLocation(
                user,
                updateUser.settings?.location || ""
            );
        }
        response = await response.json();
        if (!response.error) {
            user.settings.location = updateUser.settings?.location || "";
            toast.success("Location updated", { id: toastid });
        } else {
            toast.error(
                "Something went wrong, refresh and try again. If the issue persists, please log out and log back in",
                {
                    description: JSON.stringify(response),
                    id: toastid,
                }
            );
        }
    };
    return (
        <>
            {admin ? (
                <div className="flex items-end gap-1">
                    <Input
                        label="Location"
                        labelIcon={<IconLocation size={18} />}
                        variant="card"
                        className="w-full"
                        value={location}
                        onChange={(e) => {
                            setLocation(e.target.value);
                            setUpdateUser({
                                ...updateUser,
                                settings: {
                                    ...updateUser.settings,
                                    location: e.target.value,
                                },
                            });
                        }}
                        onBlur={onLocationBlur}
                    />
                </div>
            ) : updateUser.settings?.location === "" ? (
                <Label variant="toggle" className={`${!admin && "hidden"}`}>
                    No bio set
                </Label>
            ) : (
                <p id="user-location" className="flex items-center gap-1">
                    <IconLocation size={18} /> {updateUser.settings?.location}
                </p>
            )}
        </>
    );
}
